/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import { Tabs, Upload, Button, Icon, Spin } from 'antd';
import { DmsTab } from '../../components';
const TabPane = Tabs.TabPane;
import { openNotice, APIS, config } from 'Utils';
import { checkEntrust, saveEntrust } from '../../service/homeSet';

class homeSetEdit extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      opts: ['委托书'],
      btnLoad: false,
      loadList: false,
      key: 0,
      defaultActiveKey: 1,
      activeKey: 1,
      entrustImgData: {
        'id': '',
        'filePath': ''
      },
      entrustImgDataProps: {
        action: APIS.upload,
        onChange: this.updateEntrusImg.bind(this),
        showUploadList: false,
        listType: 'picture',
        defaultFileList: [],
        className: 'upload-img-only'
      }
    };
  }

  componentDidMount () {
    var self = this;
    self.setState({
      'loadList': true
    });
    checkEntrust().then(function (result) {
      self.setState({
        'loadList': false
      });
      if (result && result.code == 200) {
        result.data = result.data ? result.data : {};
        self.setState({
          'entrustImgData': {
            ...self.state.entrustImgData,
            'id': result.data.id || '',
            'filePath': result.data.filePath || ''
          }
        });
      } else {
        openNotice('error', '获取数据失败', (result && result.message) ? result.message : '');
      }
    });
  }

  updateEntrusImg (result) {
    /* 更新委托书模版 */
    if (result.file.status === 'done') {
      var responseData = result.file.response || {};
      if (responseData.code != 200) {
        openNotice('error', '图片上传失败');
        return;
      }
      this.setState({
        'entrustImgData': {
          ...this.state.entrustImgData,
          'id': responseData.data.id,
          'filePath': responseData.data.filePath
        }
      });
    }
  }

  deleteEntrusImg () {
    /* 删除委托书模版 */
    this.setState({
      'entrustImgData': {
        ...this.state.entrustImgData,
        'id': '',
        'filePath': ''
      }
    });
  }

  saveFn () {
    var self = this;
    self.setState({
      'btnLoad': true
    });
    if (!self.state.entrustImgData.id) {
      openNotice('warning', '提示', '请上传委托书模版');
      return;
    }
    saveEntrust(self.state.entrustImgData.id).then(function (result) {
      self.setState({
        'btnLoad': false
      });
      if (result && result.code == 200) {
        openNotice('success', '保存成功', '');
      } else {
        openNotice('error', '保存失败', result.message || '');
      }
    });
  }

  tabFn (key) {
    let self = this;
    self.setState({
      activeKey: key
    });
  }

  stopUp (e) {
    e.stopPropagation();
  }
  render () {
    const { opts, key, defaultActiveKey, entrustImgData, entrustImgDataProps } = this.state;
    var self = this;
    return <div>
      <DmsTab options={opts} defaultKey={key}>
        <Button loading={this.state.btnLoad} type='primary' onClick={this.saveFn.bind(this)}>保存</Button>
      </DmsTab>
      <Spin spinning={this.state.loadList}>
        <div className="dms-table-box">
          <Tabs defaultActiveKey={defaultActiveKey + ''} onChange={this.tabFn.bind(this)}>
            <TabPane tab="委托书模版" key="1">
              <div className="img_icon">
                <Upload {...entrustImgDataProps}>
                  <span className="ti" onClick={self.stopUp.bind(self)}>图片上传</span>
                  <Button>
                    <Icon type="upload" />
                  </Button>
                </Upload>
                <div className="set_upload_img" style={{display: entrustImgData.filePath.length==0 ? 'none': 'block'}}>
                  <img src={`${config.server}` + entrustImgData.filePath} alt="" />
                  <i className="anticon anticon-delete" onClick={self.deleteEntrusImg.bind(self)}></i>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Spin>
    </div>
  }
}
;
export default homeSetEdit;


// WEBPACK FOOTER //
// ./src/routes/entrust/edit.js